module.exports = __webpack_public_path__ + "img/微信图片_20230901145218.31a90f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/微信图片_20230901145218.png
// module id = YcHb
// module chunks = 1